export default __webpack_public_path__ + "8a33acab47ba5fcc428ceff39632ef51.png";